import { render, staticRenderFns } from "./ShipmentDetails.vue?vue&type=template&id=2881ff09&scoped=true"
import script from "./ShipmentDetails.vue?vue&type=script&lang=js"
export * from "./ShipmentDetails.vue?vue&type=script&lang=js"
import style0 from "./ShipmentDetails.vue?vue&type=style&index=0&id=2881ff09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2881ff09",
  null
  
)

export default component.exports